interface Options {
  fractionSize?: 0 | 1 | 2;
}

const COMPACT_LOCALE = 'en-US';

const compactFormatters: Partial<Record<0 | 1 | 2, Intl.NumberFormat>> = {};

function getCompactFormatter(fractionSize: 0 | 1 | 2): Intl.NumberFormat {
  let formatter = compactFormatters[fractionSize];
  if (!formatter) {
    formatter = new Intl.NumberFormat(COMPACT_LOCALE, {
      notation: 'compact',
      compactDisplay: 'short',
      minimumFractionDigits: fractionSize,
      maximumFractionDigits: fractionSize,
    });
    compactFormatters[fractionSize] = formatter;
  }
  return formatter;
}

export function abbreviatedNumber(number: number, { fractionSize = 1 }: Options = {}): string {
  return getCompactFormatter(fractionSize).format(number);
}
